<template>
  <div :class="$style.home">
    <div :class="$style.header">
      <span>首页</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt="" @click="close">
    </div>
    <main>
      <div :class="$style.bannerWrapper">
        <div :class="$style.slideWrapper" ref="slide">
          <div :class="$style.slideContent">
            <img v-for="item in banner_list" :class="$style.slidePage" :key="item.article_id" :src="item.banner" @click="redirectArticle(item, 1)" />
          </div>
        </div>
        <div :class="$style.dotsWrapper">
          <span
            v-for="(item, index) in banner_list"
            :key="item.article_id"
            :class="[$style.dot, currentPageIndex === index ? $style.active : '']"
          ></span>
        </div>
      </div>
      <div :class="$style.msg">
        <h1>资讯</h1>
        <p v-for="(msgItem, msgIndex) in article_list" :key="msgIndex" @click="redirectArticle(msgItem)">
          <img :src="`${$cdnLink}/suspend/shouye/sanjiao.png`" alt="">
          <span>{{ msgItem.name }}</span>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import Slide from "@better-scroll/slide";
import { mapState } from 'vuex';
import { buryReport } from '@/libs/business/account'

BScroll.use(Slide);

export default {
  name: "",
  data() {
    return {
      currentPageIndex: 0,
      slide: null
    };
  },
  mounted() {
    if (this.banner_list && !this.slide) {
      setTimeout(() => {
        this.scrollInit()
      }, 200); 
    }
  },
  computed: {
    ...mapState({
      banner_list: state => state.suspend.banner_list,
      article_list: state => state.suspend.article_list
    })
  },
  watch: {
    banner_list(val) {
      if (val && !this.slide) {
        setTimeout(() => {
          this.scrollInit()
        }, 200);
      }
    }
  },
  beforeUnmount() {
    this.slide && this.slide.destroy();
  },
  methods: {
    close() {
      this.$emit('close')
    },
    scrollInit() {
      this.slide = new BScroll(this.$refs.slide, {
        scrollX: true,
        scrollY: false,
        slide: true,
        momentum: false,
        bounce: false,
        probeType: 3,
        click: true
      });

      this.slide.on("slideWillChange", (page) => {
        this.currentPageIndex = page.pageX;
      });
    },
    redirectArticle(art, burnFlag) {
      this.$store.commit('suspend/CHANGE_STATE', {
        redirectArticle: {
          type: art.type,
          article_id: art.article_id,
          menu_id: art.menu_id,
        },
        active_menu_type: art.type == 2 ? 'raiders' : 'messages'
      })
      if (burnFlag) buryReport('HOME_PAGE_BANNER');
      this.$emit('redirectArticle', art.type);
    }
  },
};
</script>

<style lang="scss" module>
@import './common.scss';

.home {
  @include common-h5-wrap();
  .bannerWrapper {
    position: relative;
    width: 323px;
    height: 210px;
    margin: 10px auto 0;
    border-radius: 10px;
    .slideWrapper {
      width: 100%;
      height: 190px;
      border-radius: 5px;
      background: #000000;
      overflow: hidden;
    }
    .slideContent {
      width: 100%;
      height: 100%;
      white-space: nowrap;
      font-size: 0;
      border-radius: 5px;
      .slidePage {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .dotsWrapper {
      text-align: center;
      margin-top: 4px;
      .dot {
        display: inline-block;
        margin: 0 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #A6A6A6;
        transition: width 0.1s linear;
        &.active {
          width: 20px;
          border-radius: 5px;
          background: #FF5955;
        }
      }
    }
  }
  .msg {
    > h1 {
      font-size: 12px;
      position: relative;
      margin-left: 13px;
      padding-left: 4px;
      margin-bottom: 10px;
      &:after {
        position: absolute;
        content: ' ';
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        background: #FF5955;
        border-radius: 1px;
      }
    }
    > p {
      padding-left: 18px;
      font-size: 12px;
      color: #959595;
      line-height: 17px;
      > img {
        width: 5px;
        margin-right: 3px;
      }
    }
  }
}
</style>